import React, {Component} from 'react';
import PageHeader from "../PageHeader";
import Menu from "../Menu";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import axios from "axios";


export class ChiocoinsHistory extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            chioCoins: [],
            sum: 0,
        };
    }

    componentDidMount() {

        let urlAPI = GlobalVariable.staffBack() + '/getChioCoinStaff';
        const data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "GET",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                this.setState({
                    chioCoins: result.data.body,
                    sum: result.data.sum
                })
            }).catch(error => {
            this.setState({})

        })
    }
    renderNotChioCoins(){
        if(this.state.chioCoins.length == 0){
            return(
                <div>
                    <div className='mb-3 pl-3 pr-3   text-center'>На данный момент у вас нет Чио Койнов</div>
                    <div className='mt-5 mb-5 pl-3 pr-3   text-center'>Для получения информации по Чио Койнам подпишитесь на телеграмм канал мастеров Чио Чио <br/><a style={{textDecoration:'underline!important'}} target={'_blank'}  href={"https://t.me/masterachiochio"}>https://t.me/masterachiochio</a></div>

                </div>

            )
        }
    }

    renderContent() {
        return (
            <div>
                <div className="chio-card p-3 mb-3">
                    <div className="txt-large bold mb-2">ЧиоКоины — это внутренняя валюта в приложении.</div>
                    <div className="mb-2">
                        <b>Как копить:</b><br />
                        Начисляем ЧиоКоины за выполнение челленджей в мобильном приложении и за участие в конкурсах компании.
                    </div>
                    <div className="mb-2">
                        <b>Когда сгорают:</b><br />
                        Баланс ЧиоКоинов сгорает, если ты перестаешь работать в нашей сети парикмахерских Чио Чио.
                    </div>
                    <div>
                        <b>Как тратить:</b><br />
                        За ЧиоКоины можно купить приз в бенефит кафе приложения.
                    </div>
                </div>
                <div className='pl-3 pr-3 '>
                    <div className='mb-3 pl-3 pr-3 txt-large bold text-center'>
                        Баланс {this.state.sum} <img src='/img/icons/chiocoins.svg' height='22px' style={{marginTop: '-5px'}}
                                         alt=''/>
                    </div>
                    {this.renderNotChioCoins()}
                    {
                        this.state.chioCoins.map((item)=>(
                            <div className='chio-card mb-2 pl-3 pr-3 pt-2 pb-2'>
                                <div className='txt-middle d-flex justify-content-end'>{item.date}</div>
                                <div className='txt-middle bold'>
                                    {item.paid} <img src='/img/icons/chiocoins.svg' height='15px' style={{marginTop: '-3px'}} alt=''/>
                                </div>
                                <div className='txt-middle'>{item.title}</div>
                            </div>
                        ))
                    }



                </div>

            </div>
        )
    }


    render() {
        return (
            <div className='main lesson'>
                <div className='content mx-w-content'>

                    <PageHeader
                        pageTitle='Чиокоины история'
                        backBtnUrl='/'/>
                    <div className='pt-header'></div>

                    {this.renderContent()}
                </div>
                <Menu/>
            </div>
        )
    }
}

export default ChiocoinsHistory;